export enum AuthRoutes {
  login = 'auth/login',
  remindPassword = 'auth/remind-password',
  setPassword = 'auth/set-password',
  resetPassword = 'auth/reset-password',
  emailVerification = 'auth/email-verification',
}